import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import * as RadixSelect from '@radix-ui/react-select';
import { SelectGroup } from '@radix-ui/react-select';
import { Fragment } from 'react';
import { FaCheck, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { Portal } from '../root-layout/Portal';
const SelectRoot = styled.div `
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  font-size: 1.125em;
  width: 120px;
`;
const SelectTrigger = styled(RadixSelect.Trigger) `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 4px 11px;
  user-select: none;
  font-size: 1.125em;
  line-height: 1.125em;

  &[data-disabled] {
    color: rgba(0, 0, 0, 0.5);
    background-color: #f5f5f5;
  }
`;
const SelectContent = styled(RadixSelect.Content) `
  width: var(--radix-select-trigger-width);
  max-height: var(--radix-select-content-available-height);
`;
const SelectViewport = styled(RadixSelect.Viewport) `
  width: var(--radix-select-trigger-width);
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: white;
  padding: 5px;
`;
const SelectItem = styled(RadixSelect.Item) `
  user-select: none;
  font-size: 1.125em;
  padding: 4px 11px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background-color: #e6f4ff;
  }
  &[data-disabled] {
    color: rgba(0, 0, 0, 0.5);
  }
`;
const SelectLabel = styled(RadixSelect.Label) `
  color: rgba(0, 0, 0, 0.5);
  font-size: 1em;
  padding: 4px 11px;
  margin-top: 8px;
`;
const SelectItemIndicator = styled(RadixSelect.ItemIndicator) `
  right: 0;
  width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
const SelectSeparator = styled(RadixSelect.Separator) `
  height: 1px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  margin: 5px 0;
`;
export function Select(props) {
    const { placeholder, value, onSelect, options, disabled = false, style, } = props;
    const selectedLabel = options
        .flatMap((group) => group.flatMap((optionOrCategory) => 'options' in optionOrCategory
        ? optionOrCategory.options
        : [optionOrCategory]))
        .find((option) => option.value === value)?.label;
    return (_jsx(SelectRoot, { style: { ...style }, children: _jsxs(RadixSelect.Root, { value: value, onValueChange: onSelect, disabled: disabled, children: [_jsxs(SelectTrigger, { children: [_jsx(RadixSelect.Value, { children: _jsxs("span", { children: [selectedLabel || placeholder, "\u00A0"] }) }), _jsx(RadixSelect.Icon, { asChild: true, children: _jsx(FaChevronDown, {}) })] }), _jsx(Portal, { children: _jsxs(SelectContent, { position: "popper", children: [_jsx(RadixSelect.ScrollUpButton, { children: _jsx(FaChevronUp, {}) }), _jsx(SelectViewport, { children: options.map((group, groupIndex) => (_jsxs(Fragment, { children: [group.map((optionOrCategory, optionOrCategoryIndex) => 'options' in optionOrCategory ? (_jsxs(SelectGroup, { children: [_jsx(SelectLabel, { children: optionOrCategory.label }), optionOrCategory.options.map((option) => (_jsxs(SelectItem, { value: option.value, disabled: option.disabled, children: [_jsx(RadixSelect.ItemText, { children: option.label }), _jsx(SelectItemIndicator, { children: _jsx(FaCheck, {}) })] }, option.value)))] }, optionOrCategoryIndex)) : (_jsxs(SelectItem, { value: optionOrCategory.value, disabled: optionOrCategory.disabled, children: [_jsx(RadixSelect.ItemText, { children: optionOrCategory.label }), _jsx(SelectItemIndicator, { children: _jsx(FaCheck, {}) })] }, optionOrCategory.value))), groupIndex < options.length - 1 && _jsx(SelectSeparator, {})] }, groupIndex))) }), _jsx(RadixSelect.ScrollDownButton, {}), _jsx(RadixSelect.Arrow, {})] }) })] }) }));
}
//# sourceMappingURL=Select.js.map